import { PropsWithChildren } from 'react';

import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';

import {
  AccountingSystemFormType,
  Form,
  getSchema,
} from '../../forms/accountingSystemForm';

export interface AccountingSystemFormProps {
  initialValues?: Partial<AccountingSystemFormType>;
  onSubmit: FormSubmit<AccountingSystemFormType>;
}

export const AccountingSystemForm = ({
  initialValues,
  children,
  onSubmit,
}: AccountingSystemFormProps & PropsWithChildren) => {
  const { t } = useTranslation();

  const schema = getSchema(t);

  return (
    <Form
      initialReadOnly
      initialValues={initialValues}
      validationSchema={schema}
      onSubmit={onSubmit}
    >
      {children}
    </Form>
  );
};
